__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "questionBuilderWebapp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "12.2.17", () => (Promise.all([__webpack_require__.e(4973), __webpack_require__.e(8819), __webpack_require__.e(3401)]).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/common/__ivy_ngcc__/fesm2015/http.js */ 3401))))));
			register("@angular/common", "12.2.17", () => (Promise.all([__webpack_require__.e(8819), __webpack_require__.e(6828)]).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/common/__ivy_ngcc__/fesm2015/common.js */ 6828))))));
			register("@angular/core", "12.2.17", () => (Promise.all([__webpack_require__.e(4973), __webpack_require__.e(2232)]).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/core/__ivy_ngcc__/fesm2015/core.js */ 2232))))));
			register("@angular/router", "12.2.17", () => (Promise.all([__webpack_require__.e(4973), __webpack_require__.e(8819), __webpack_require__.e(1121), __webpack_require__.e(5060)]).then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/router/__ivy_ngcc__/fesm2015/router.js */ 5060))))));
			register("@ngx-translate/core", "13.0.0", () => (__webpack_require__.e(4121).then(() => (() => (__webpack_require__(/*! ./node_modules/@ngx-translate/core/__ivy_ngcc__/fesm2015/ngx-translate-core.js */ 4121))))));
			register("@savvaslearning/lst-auth", "2.1.0", () => (Promise.all([__webpack_require__.e(6238), __webpack_require__.e(5886)]).then(() => (() => (__webpack_require__(/*! ./node_modules/@savvaslearning/lst-auth/fesm2015/savvaslearning-lst-auth.js */ 5886))))));
			register("apollo-angular", "1.10.0", () => (__webpack_require__.e(5847).then(() => (() => (__webpack_require__(/*! ./node_modules/apollo-angular/__ivy_ngcc__/fesm2015/ngApollo.js */ 5847))))));
			register("apollo-client", "2.6.10", () => (Promise.all([__webpack_require__.e(7935), __webpack_require__.e(4058)]).then(() => (() => (__webpack_require__(/*! ./node_modules/apollo-client/bundle.esm.js */ 4058))))));
			register("rxjs/operators", "6.6.7", () => (Promise.all([__webpack_require__.e(7195), __webpack_require__.e(1286)]).then(() => (() => (__webpack_require__(/*! ./node_modules/rxjs/_esm2015/operators/index.js */ 8905))))));
			register("rxjs", "6.6.7", () => (Promise.all([__webpack_require__.e(7195), __webpack_require__.e(1688)]).then(() => (() => (__webpack_require__(/*! ./node_modules/rxjs/_esm2015/index.js */ 1688))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};